import { IconWithTooltip, labelToDataId } from "@flexidao/ui-lib";
import { TooltipType } from "@flexidao/ui-lib/components/overlays/icon-with-tooltip/types";
import { Group, Stack, Text, Title } from "@mantine/core";
import { ReactElement } from "react";

export type SectionTitleProps = {
    label: string;
    tooltip?: TooltipType;
    dataId: string;
    description?: string;
};

export const SectionTitle = ({
    label,
    tooltip,
    dataId,
    description,
}: SectionTitleProps): ReactElement => (
    <Stack spacing={0}>
        <Group spacing={4} data-id={labelToDataId({ prefix: dataId, label: "title" })}>
            <Title order={3}>{label}</Title>
            {tooltip && (
                <IconWithTooltip
                    tooltip={tooltip}
                    dataId={labelToDataId({ prefix: dataId, label: "icon-with-tooltip" })}
                />
            )}
        </Group>

        {description && (
            <Text
                data-id={labelToDataId({
                    prefix: dataId,
                    label: "description",
                })}
            >
                {description}
            </Text>
        )}
    </Stack>
);
